import { createReducer, on } from '@ngrx/store';
import { Event } from '../../models';
import * as actions from '../actions/featured-events.action';
import { ToEntities } from '@teamfoster/sdk/array-utility';

export interface FeaturedEventsState {
  entities: { [id: number]: Event };
  loaded: boolean;
  loading: boolean;
  error?: any;
}

export const initialState: FeaturedEventsState = {
  entities: {},
  loaded: false,
  loading: false,
};

export const FeaturedEventsReducer = createReducer(
  initialState,

  on(actions.LoadFeaturedEvents, (state: FeaturedEventsState) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(actions.LoadFeaturedEventsSuccess, (state: FeaturedEventsState, { events }) => {
    const entities = ToEntities(events, 'id', {});

    return {
      ...state,
      entities,
      loading: false,
      loaded: true,
    };
  }),
  on(actions.LoadFeaturedEventsFail, (state: FeaturedEventsState, { error }) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      error,
    };
  })
);

export const getFeaturedEventsEntities = (state: FeaturedEventsState) => state.entities;
export const getFeaturedEventsLoading = (state: FeaturedEventsState) => state.loading;
export const getFeaturedEventsLoaded = (state: FeaturedEventsState) => state.loaded;
export const getFeaturedEventsError = (state: FeaturedEventsState) => state.error;
